import { CTAFunction } from "../../api/cta/ctaFunction/CTAFunction";

export class CTAResource {
  constructor(
    public ctaFunction: CTAFunction,
    public html: string,
  ) {}
}
